// extracted by mini-css-extract-plugin
module.exports =  {"button":"ccc2a9d5f9--button--GVLSF"};